import { useEffect } from 'react';
import logo from '../images/logo.png';
const About = () => {
  useEffect(() => {
    document.title = 'Kwiecińscy - Zakład Mięsny';
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="about-section">
      <div className="container">
        <h2>O nas</h2>
        <img src={logo} alt="logo" />
        <p>
          Zakład Mięsny Kwiecińscy jest małą rodzinną firmą. Zajmujemy się
          przetwórstwem i sprzedażą mięsa wieprzowego. Posiadamy sieć własnych
          sklepów firmowych, również zaopatrujemy szkoły i restauracje. Ponad
          ćwierć wieku istnienia zaowocowało stworzeniem wielu własnych,
          niepowtarzalnych receptur i uznaniem wśród naszych klientów. Cenimy
          sobie najwyższą jakość oferowanych przez nas produktów, dlatego
          zaopatrujemy się w żywiec tylko od lokalnych hodowców, a regularny
          ubój jest gwarancją świeżości naszych towarów.
        </p>
      </div>
    </section>
  );
};

export default About;
